import React from "react";
import { updateProgress } from "../../Api";
import secureLocalStorage from "react-secure-storage";

const CheckInStep4 = ({ activeItems, toggleSubMenu, handleNext }) => {
  const isActive = (item) => activeItems.includes(item);

  const handleToggle = (item) => {
    const groupItems = [
      "activity-0",
      "activity-1",
      "activity-2",
      "activity-3",
      "activity-4",
    ];
    groupItems.forEach((activeItem) => {
      if (isActive(activeItem)) {
        toggleSubMenu(activeItem);
      }
    });
    toggleSubMenu(item);
  };

  const groupItems = [
    "activity-0",
    "activity-1",
    "activity-2",
    "activity-3",
    "activity-4",
  ];

  const activityLabels = [
    "Sedentary",
    "Lightly active",
    "Moderate",
    "Quite active",
    "Very active",
  ];

  const handleUpdateProgress = async () => {
    const activity = groupItems.findIndex((activityLevel) =>
      isActive(activityLevel)
    );

    const patient_id = secureLocalStorage.getItem("patient_id");
    const rawWeekNo = parseInt(secureLocalStorage.getItem("week_no"));
    const week_no = rawWeekNo ? Math.abs(rawWeekNo) : 1;
    const pain = localStorage.getItem("pain_level");
    const motivation = localStorage.getItem("motivation");

    try {
      await updateProgress(patient_id, pain, motivation, activity + 1, week_no);
    } catch (error) {
      console.error("Error updating progress:", error);
    }

    handleNext();
  };

  const isItemActive = groupItems.some(isActive);

  return (
    <div className="modal-container animated-onboarding onboarding-step5 fadeIn">
      <div className="modal-container-title fade1 heading">
        <h3>How active have you been lately?</h3>
      </div>

      <ul className="selection selection-flex-col selection-ico fade3 with-box-icon nowrap mt-50 gap-10">
        {groupItems.map((activityLevel, index) => (
          <li
            key={activityLevel}
            className={`with-icon ${isActive(activityLevel) ? "active" : ""}`}
            onClick={() => handleToggle(activityLevel)}
          >
            <p className="icon-index">{index + 1}</p>
            <div className={`div-ico ico ico-activity-${index}`}></div>
            <span className={`icon icon-${index}`}></span>
            <p className="icon-text">{activityLabels[index]}</p>
          </li>
        ))}
      </ul>
      {isItemActive && (
        <>
          <div className="nav-container fade-fast">
            <button
              className="btn-next next-btn"
              onClick={handleUpdateProgress}
            >
              Done
            </button>
          </div>
          <div className="dot-container fade-fast">
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-unchecked"></div>
            <div className="dot-checked"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default CheckInStep4;
